import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=209ddfe3&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=209ddfe3&prod&scoped=true&lang=scss"
import style1 from "./ChatView.vue?vue&type=style&index=1&id=209ddfe3&prod&lang=scss"
import style2 from "./ChatView.vue?vue&type=style&index=2&id=209ddfe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ddfe3",
  null
  
)

export default component.exports